export default () => ({
	min: 7,
	speed: 0.2,
    wrapper: null,
	init() {
        this.wrapper = this.$root.querySelector('.wrapper');
		let count = this.wrapper.children.length;
		while (count < this.min) {
			[...this.wrapper.children].forEach((v, i, a) => {
				if (count < this.min) {
					this.wrapper.appendChild(v.cloneNode(true));
				}
				++count;
			});
		}
	},
	marquee() {
		let firstElement = this.wrapper.children[0];
		let i = 0;
		setInterval(() => {
			this.wrapper.style.marginLeft = `-${i}px`;
			if (i > firstElement.clientWidth) {
                this.wrapper.style.marginLeft = '';
                this.wrapper.insertAdjacentElement('beforeend', firstElement.cloneNode(true));
				firstElement.remove();
                firstElement = this.wrapper.children[0];
				i = 0;
			}
			i = i + this.speed;
		}, 0);
	},
});
